import angular from 'angular';
import imagePreviewThumb from './imagePreviewThumb';

export default angular
  .module('components.imagePreviewThumb', [])
  .component('imagePreviewThumb', imagePreviewThumb).name;
